import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  FormControlLabel, CircularProgress, Autocomplete
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import SubcompanyApi from "Services/Subcompany";

//Data
import countryCodeData from "./data/countryCode/index.json";
import CountryCodeDropdown from "SharedComponents/CountryCodeDropdown";
import { getCountryCodes } from "Utils/country";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SubcmpnyUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

  const [countryCodeData, setCountryCodeData] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(true);

  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };

  // Dropzone props
  const { getRootProps, getInputProps, open, fileRejections } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 1,
    accept: "image/*",
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
      if (acceptedFiles && fileLength < maxFileSize) {
        const file = acceptedFiles[0];
        //console.log("typeof file-->", typeof(file));

        // Convert file to Base64
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result;
          formik.setFieldValue("passengerProfileImagefile", file);
          formik.setFieldValue("passengerProfileImage", base64String); // Keep the file for form submission
        };
        reader.onerror = (error) => {
          console.error("Error converting file to Base64:", error);
        };
        reader.readAsDataURL(file); // Convert file to Base64
      }
    },
  });

  // Fetch subcompany Details

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    SubcompanyApi.getSubcmpnyDetails(id).then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const handleUpdateSubcmpny = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

    const data = {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      countryCode: formValues?.countryCode,
      mobileNumber: formValues?.mobile,
      email: formValues?.email,
      image: formValues?.passengerProfileImagefile,
      gender: formValues?.gender,
      country: formValues?.country,
      sub_companyName: formValues?.subcompanyname,
    };

    //console.log('data--->',data);

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Sub-company Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while Update Sub-company",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      SubcompanyApi.updateSubcmpny(id, { ...data }).then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const countries = getCountryCodes();
        setCountryCodeData(countries);
        setLoadingCountries(false);
      } catch (error) {
        console.error('Error fetching country codes:', error);
        setLoadingCountries(false);
      }
    };

    fetchCountryCodes();
  }, [])
  // Formik - Set fetched values for master
  useEffect(() => {
    const updateFormValues = async () => {
      if (!_.isEmpty(details)) {
        formik.setFieldValue("firstName", details?.firstName);
        formik.setFieldValue("lastName", details?.lastName);
        formik.setFieldValue("subcompanyname", details?.sub_companyName);
        formik.setFieldValue("countryCode", details?.countryCode);
        formik.setFieldValue("mobile", details?.mobileNumber);
        formik.setFieldValue("email", details?.email);
        formik.setFieldValue("passengerProfileImage", details?.image);
        formik.setFieldValue("passengerProfileImagefile", details?.image);
        formik.setFieldValue("gender", details?.gender);
        formik.setFieldValue("country", details?.country);
      }
    }
    updateFormValues();
  }, [details]);

  // Formik

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      subcompanyname: "",
      password: "",
      passConfirmation: "",
      gender: "",
      country: "",
      mobile: "",
      countryCode: "",
      passengerProfileImage: "",
      passengerProfileImagefile: ""
    },
    validationSchema: yup.object({
      firstName: yup.string().required("First Name is required").nullable(),
      subcompanyname: yup.string().required("Sub-company name is required").nullable(),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required")
        .nullable(),
      countryCode: yup.string().required("Country Code is required").nullable(),
      mobile: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Mobile is required")
        .nullable(),
      gender: yup.string().required("Gender is required").nullable(),
      country: yup.string().required("Country is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateSubcmpny,
  });

  const countryCodes = Object.keys(countryCodeData);

  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Update Sub-company
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <section className={classes.avatarContainer}>
                <div className={classes.avatarWrapper}>
                  <div className={classes.avatar}>
                    <img
                      src={formik?.values?.passengerProfileImage ?
                        formik?.values?.passengerProfileImage :
                        "/assets/images/user/avatar.png"
                      }
                      alt="avatar"
                      className={classes.img}
                      style={{ objectFit: "cover" }}
                    />
                    <section
                      {...getRootProps()}
                      onClick={open}
                      className={classes.editIcon}
                    >
                      <input {...getInputProps()} />
                      <CameraAltOutlinedIcon />
                    </section>
                  </div>
                </div>
              </section>
            </Grid>
          </Grid>
          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>
                      <Grid item xs={12} md={12} lg={12}>
                        <Grid container>
                          <Grid
                            item
                            md={6}
                            lg={6}
                            xl={6}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                              id="firstName"
                              label="First Name"
                              value={formik?.values?.firstName}
                              defaultValue={formik?.values?.firstName}
                              onChange={formik.handleChange}
                              error={
                                formik?.errors?.firstName &&
                                formik?.touched?.firstName
                              }
                              helperText={
                                formik?.errors?.firstName &&
                                formik?.touched?.firstName &&
                                formik?.errors?.firstName
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            ></TextField>
                          </Grid>
                          <Grid
                            item
                            md={6}
                            lg={6}
                            xl={6}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                              name="lastName"
                              id="lastName"
                              label="Last Name"
                              value={formik?.values?.lastName}
                              defaultValue={formik?.values?.lastName}
                              onChange={formik?.handleChange}
                              error={
                                formik?.errors?.lastName &&
                                formik?.touched?.lastName
                              }
                              helperText={
                                formik?.errors?.lastName &&
                                formik?.touched?.lastName &&
                                formik?.errors?.lastName
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="subcompanyname"
                          id="subcompanyname"
                          label="Sub-company name"
                          value={formik?.values?.subcompanyname}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.subcompanyname && formik?.touched?.subcompanyname
                          }
                          helperText={
                            formik?.errors?.subcompanyname &&
                            formik?.touched?.subcompanyname &&
                            formik?.errors?.subcompanyname
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid item md={12} lg={12} xl={12}>
                        <Grid container>
                          <Grid
                            item
                            md={4}
                            lg={4}
                            xl={4}
                            className={classes.textFieldWrapper}
                          >
                            <CountryCodeDropdown
                              formik={formik}
                              countryCodeData={countryCodeData}
                              name="countryCode"
                              id="countryCode"
                              label=""
                              error={formik?.errors?.countryCode && formik?.touched?.countryCode}
                              helperText={
                                formik?.errors?.countryCode &&
                                formik?.touched?.countryCode &&
                                formik?.errors?.countryCode
                              }
                              roundedInputStyle={{}}
                            />
                          </Grid>
                          <Grid
                            item
                            md={8}
                            lg={8}
                            xl={8}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                              name="mobile"
                              id="mobile"
                              label="Mobile Number"
                              value={formik?.values?.mobile}
                              defaultValue={formik?.values?.mobile}
                              onChange={formik?.handleChange}
                              error={
                                formik?.errors?.mobile &&
                                formik?.touched?.mobile
                              }
                              helperText={
                                formik?.errors?.mobile &&
                                formik?.touched?.mobile &&
                                formik?.errors?.mobile
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        name="email"
                        id="email"
                        label="Email"
                        value={formik?.values?.email}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.email && formik?.touched?.email
                        }
                        helperText={
                          formik?.errors?.email &&
                          formik?.touched?.email &&
                          formik?.errors?.email
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        name="gender"
                        id="gender"
                        select
                        label="Gender"
                        value={formik?.values?.gender || ""}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.gender && formik?.touched?.gender
                        }
                        helperText={
                          formik?.errors?.gender &&
                          formik?.touched?.gender &&
                          formik?.errors?.gender
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        {["male", "female"].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option.charAt(0).toUpperCase() + option.slice(1)}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                          form: {
                            autocomplete: 'off',
                          },
                        }}
                        name="country"
                        id="country"
                        select
                        label="Country"
                        value={formik?.values?.country || ""}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.country && formik?.touched?.country
                        }
                        helperText={
                          formik?.errors?.country &&
                          formik?.touched?.country &&
                          formik?.errors?.country
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        {countryCodeData.map((country) => (
                          <MenuItem
                            key={country.code}
                            value={country.name}
                          >
                            {`${country.code} (${country.name})`}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.sbtBtnWrapper}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                      Update Sub-company
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </section>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubcmpnyUpdate;
